import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import VatDocumentIndexPage from '../containers/VatDocuments'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const VatDocumentsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'vat_documents') {
			dispatch(changeCurrent(['vat_documents']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={VatDocumentIndexPage} exact />
		</Switch>
  )
}

VatDocumentsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

VatDocumentsPage.defaultProps = {}

export default VatDocumentsPage
